var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"form-element-textarea-demo"}},[_c('textarea-default'),_c('textarea-label'),_c('textarea-counter'),_c('textarea-height')],1)}
var staticRenderFns = []

export { render, staticRenderFns }